"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenRenewal = exports.tryApiFetchNoBearer = exports.tryApiFetchNoJson = exports.tryApiFetch = void 0;
var errors_1 = require("./errors");
var logger_1 = __importDefault(require("./logger"));
var jsonwebtoken_1 = require("jsonwebtoken");
var logger = logger_1.default('utils');
/**
 * General try fetch call for the sounditi API
 *
 * As fetch only fails is there is a network error
 * it throw a ConnectionError in that case
 *
 * @param {string} endPoint The endpoint
 * @param {FetchOptions} [options= {}] The fetch options
 * @param {string} [options.method = 'GET'] HTTP VERB to use.
 * @param {object} [options.body =  {}] The request body
 *
 * @throws {ConnectionError} Error when the connection is wrong
 *
 * @returns JSON response
 *
 * @category UTILS
 */
function tryApiFetch(endPoint, token, options) {
    if (token === void 0) { token = ''; }
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var method, body, params, res, jsonRes, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    method = options.method || 'GET';
                    body = options.body || {};
                    method.toUpperCase();
                    switch (method) {
                        case 'GET':
                            params = {
                                method: method,
                                headers: {
                                    Authorization: "Bearer " + token,
                                }
                            };
                            break;
                        case 'POST':
                            params = {
                                method: method,
                                headers: {
                                    Authorization: "Bearer " + token,
                                },
                                body: body
                            };
                            break;
                        case 'PATCH':
                            params = {
                                method: method,
                                headers: {
                                    Authorization: "Bearer " + token,
                                },
                                body: body
                            };
                            break;
                        default:
                            params = {
                                method: method,
                                headers: {
                                    Authorization: "Bearer " + token,
                                }
                            };
                            break;
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(endPoint, params)];
                case 2:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 3:
                    jsonRes = _a.sent();
                    return [2 /*return*/, jsonRes];
                case 4:
                    error_1 = _a.sent();
                    throw new errors_1.ConnectionError(error_1.message);
                case 5: return [2 /*return*/];
            }
        });
    });
}
exports.tryApiFetch = tryApiFetch;
/**
 * General try fetch call for the sounditi API
 *
 * @param {string} endPoint The endpoint
 * @param {string} token The token
 * @param {FetchOptions} [options={}] The fetch options
 * @param {string} [options.method = 'GET'] HTTP VERB to use.
 * @param {object} [options.body =  {}] The request body
 *
 * @throws {ConnectionError} Error when the connection is wrong
 *
 * @returns JSON response
 *
 * @category UTILS
 */
function tryApiFetchNoJson(endPoint, token, options) {
    if (token === void 0) { token = ''; }
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var method, body, params, res, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    method = options.method || 'GET';
                    body = options.body || {};
                    method.toUpperCase();
                    switch (method) {
                        case 'GET':
                            params = {
                                method: method,
                                headers: {
                                    Authorization: "Bearer " + token,
                                }
                            };
                            break;
                        case 'POST':
                            params = {
                                method: method,
                                headers: {
                                    Authorization: "Bearer " + token,
                                },
                                body: body
                            };
                            break;
                        case 'PUT':
                            params = {
                                method: method,
                                headers: {
                                    Authorization: "Bearer " + token,
                                },
                                body: body
                            };
                            break;
                        case 'PATCH':
                            params = {
                                method: method,
                                headers: {
                                    Authorization: "Bearer " + token,
                                },
                                body: body
                            };
                            break;
                        case 'DELETE':
                            params = {
                                method: method,
                                headers: {
                                    Authorization: "Bearer " + token,
                                },
                                body: body
                            };
                            break;
                        default:
                            params = {
                                method: method,
                                headers: {
                                    Authorization: "Bearer " + token,
                                }
                            };
                            break;
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetch(endPoint, params)];
                case 2:
                    res = _a.sent();
                    return [2 /*return*/, res];
                case 3:
                    error_2 = _a.sent();
                    throw new errors_1.ConnectionError(error_2.message);
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.tryApiFetchNoJson = tryApiFetchNoJson;
/**
 * General try fetch call for the sounditi API without Authorization header
 *
 * @param {string} endPoint The endpoint
 * @param {FetchOptions} [options={}] The fetch options
 * @param {string} [options.method = 'GET'] HTTP VERB to use.
 *
 * @throws {ConnectionError} Error when the connection is wrong
 *
 * @returns JSON response
 *
 * @category UTILS
 */
function tryApiFetchNoBearer(endPoint, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var method, body, params, res, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    method = options.method || 'GET';
                    body = options.body || {};
                    method.toUpperCase();
                    switch (method) {
                        case 'GET':
                            params = {
                                method: method
                            };
                            break;
                        case 'POST':
                            params = {
                                method: method,
                                body: body
                            };
                            break;
                        case 'PUT':
                            params = {
                                method: method
                            };
                            break;
                        default:
                            params = {
                                method: method
                            };
                            break;
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetch(endPoint, params)];
                case 2:
                    res = _a.sent();
                    return [2 /*return*/, res];
                case 3:
                    error_3 = _a.sent();
                    throw new errors_1.ConnectionError(error_3.message);
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.tryApiFetchNoBearer = tryApiFetchNoBearer;
/**
 *  Auth helper function for token renewal
*   @private
 *  @category AUTH
 *
 * @todo Move inside AUTH CLASS
 */
function tokenRenewal() {
    return __awaiter(this, void 0, void 0, function () {
        var accessToken, isExpired, renewalToken, tokenPair, tokenPayload, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 7, , 8]);
                    return [4 /*yield*/, this.auth.getToken()];
                case 1:
                    accessToken = _a.sent();
                    if (accessToken === '') {
                        throw new errors_1.TokenRenewalError('No access token found');
                    }
                    logger.debug('_authRenewal: getToken', { accessToken: accessToken });
                    return [4 /*yield*/, this.auth.checkTokenExpiration()];
                case 2:
                    isExpired = _a.sent();
                    if (!isExpired) return [3 /*break*/, 5];
                    return [4 /*yield*/, this.auth.getRenewalToken()];
                case 3:
                    renewalToken = _a.sent();
                    logger.debug('_authRenewal: campaign Access renews token');
                    return [4 /*yield*/, this.auth.renewToken(renewalToken)];
                case 4:
                    tokenPair = (_a.sent()).auth;
                    if (tokenPair) {
                        accessToken = tokenPair.accessToken;
                    }
                    else {
                        accessToken = null;
                    }
                    _a.label = 5;
                case 5:
                    ;
                    // update api token
                    this.api.token = accessToken;
                    return [4 /*yield*/, jsonwebtoken_1.decode(accessToken)];
                case 6:
                    tokenPayload = (_a.sent()) || {};
                    logger.debug('_authRenewal: tokenPayload', { tokenPayload: tokenPayload });
                    if ("sub" in tokenPayload) {
                        this.userId = tokenPayload.sub;
                        logger.debug('_authRenewal: userID decoded from accessToken', { userId: tokenPayload.sub });
                    }
                    ;
                    logger.debug('_authRenewal: userID decoded from accessToken', { userId: tokenPayload.sub });
                    return [3 /*break*/, 8];
                case 7:
                    error_4 = _a.sent();
                    logger.error('_authRenewal error', { error: error_4 });
                    throw new errors_1.TokenRenewalError(error_4.message);
                case 8: return [2 /*return*/];
            }
        });
    });
}
exports.tokenRenewal = tokenRenewal;
//# sourceMappingURL=utils.js.map